<template>
    <div id="second-strategy" data-sal="slide-up" data-sal-duration="800" data-sal-delay="100">
        <!--=====================================-->
        <!--=      Strategy Quality Area Start    =-->
        <!--=====================================-->
        <section class="section pb--80 pb_lg--40 pb_md--20">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="about-quality active mb-1">
                            <h3 class="sl-number bold mb-2 mt-5">4</h3>
                            <h2 class="title black font-weight-100 mb-4 ml-1">
                                <span class="bold">Educación y comunidad.</span>
                            </h2>
                            <p class="black mb-1">
                                La educación crea consciencia. La consciencia incita a la acción. La acción en comunidad resuena.
                                <br>
                                <br>
                            </p>

                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-xl-6">
                                    <div class="blog-list active">
                                        <div class="post-thumbnail">
                                            <img :src="getLogo('salvando')" alt="Blog Post">
                                        </div>
                                        <div class="post-content">
                                            <h5 class="bold mb-0">
                                                <br><span class="font-weight-100">Aquí, salvando al planeta (ASAP).</span>
                                            </h5>
                                            <p class="">
                                                Podcast que bajo un tono fresco
                                                e irónico, aborda temas sostenibles
                                                desde perspectivas de la sociedad
                                                civil, el gobierno y la iniciativa
                                                privada.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-xl-6">
                                    <div class="blog-list active">
                                        <div class="post-thumbnail">
                                            <img :src="getLogo('leaf')" alt="Blog Post">
                                        </div>
                                        <div class="post-content">
                                            <h5 class="bold mb-0">
                                                <br><span class="font-weight-100">Comunidad.</span>
                                            </h5>
                                            <p class="">
                                                Próximamente, lanzaremos
                                                una herramienta que fomentará
                                                el diálogo e intercambio de ideas
                                                entre la comunidad.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script scoped>

export default {
    name: "SecondStrategy",
    components: {
    },
    methods: {
        getLogo(name) {
            return `https://cdn.redgirasol.com/nuevo_portal/logos/logo-${name}.png`
        }
    }
}

</script>

<style scoped>
.about-quality .sl-number {
    background: var(--color-primary);
}

.strategy-card {
    padding: 2rem;
    background-color: var(--color-black);
    color: #FFF;
    border-radius: 25px;
    min-height: 15rem;
}

.blog-list {
    border: none !important;
}

.post-thumbnail {
    max-width: 15rem !important;
}

.blog-list {
    padding-top: 1rem !important;
}
    .blog-list .post-content p {
        overflow: visible;
    }
</style>